import { formatLatLng, getLatLng } from './checkpointLocation';

export const shapeLabel = (stop = {}) => {
  const type = (stop.geometry?.type || stop.shapeMode || stop.shapeType || '')
    .toString()
    .toLowerCase();
  if (type === 'polygon') return 'Polygon';
  if (type === 'crossline') return 'Crossline';
  return 'Circle';
};

export const modeLabel = (mode) => {
  const normalized = (mode || 'DRIVING').toString().toUpperCase();
  if (normalized === 'WALK' || normalized === 'WALKING') return 'Walking';
  if (normalized === 'INDOOR') return 'Indoor';
  return 'Driving';
};

export const formatAddress = (stop = {}) => {
  const trimmed = (stop.address || '').trim();
  if (trimmed) return trimmed;
  const latLng = getLatLng(stop);
  if (latLng) return `${latLng.lat.toFixed(5)}, ${latLng.lng.toFixed(5)}`;
  return 'No address provided';
};

const resolveZoneLabel = (zoneId, zones) => {
  if (zoneId == null) return '';
  const zone = zones.find((z) => `${z.id}` === `${zoneId}`);
  return zone?.name || (zoneId != null ? `Zone ${zoneId}` : '');
};

export const formatLocationLabel = (stop = {}, zones) => {
  const zoneId = stop?.zoneId ?? stop?.geometry?.zoneId ?? stop?.zone_id ?? null;
  const zoneLabel = resolveZoneLabel(zoneId, zones);
  if (zoneLabel) return zoneLabel;
  return formatAddress(stop);
};

export const formatCoords = (stop = {}) => {
  return formatLatLng(stop);
};
